import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { CONTACT_LINKS } from "@/lib/site-data";

export default function FinalCTA() {
  return (
    <section
      id="get-started"
      data-testid="final-cta"
      className="relative overflow-hidden bg-forest text-cream"
    >
      <div
        aria-hidden="true"
        className="absolute -top-40 -right-40 h-[460px] w-[460px] rounded-full bg-clay/20 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-32 -left-24 h-[360px] w-[360px] rounded-full bg-cream/10 blur-3xl"
      />

      <div className="container-x relative py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <p className="text-[12.5px] font-semibold uppercase tracking-[0.18em] text-clay">
            Ready when you are
          </p>
          <h2 className="mt-4 font-display text-cream text-[40px] sm:text-[56px] lg:text-[72px] font-extrabold leading-[1.02] tracking-tight text-balance">
            Making better health <br className="hidden lg:block" />
            possible  everywhere.
          </h2>
          <p className="mt-6 text-[17px] text-cream/80 max-w-xl leading-relaxed">
            Start a conversation in 30 seconds. No app to install, no insurance required, no waiting room.
          </p>
        </div>

        <div className="lg:col-span-5">
          <div className="flex flex-col gap-3">
            <a
              href={CONTACT_LINKS.whatsapp.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp"
              className="group inline-flex items-center justify-between rounded-2xl bg-cream text-ink px-6 py-5 hover:-translate-y-0.5 transition-transform shadow-md"
            >
              <span className="flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-forest text-cream">
                  <MessageCircle className="h-5 w-5" />
                </span>
                <span className="text-left">
                  <span className="block text-[12px] uppercase tracking-[0.18em] text-ink/55">
                    Start on WhatsApp
                  </span>
                  <span className="block font-display text-[18px] font-bold">
                    {CONTACT_LINKS.whatsapp.label}
                  </span>
                </span>
              </span>
              <ArrowRight className="h-5 w-5 text-ink/60 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
